import api from "./api";

export const careCapableUserLabel = (user, t) => {
  const translate = t || ((key) => ({
    superAdmin: "Super Admin", admin: "Admin", care_manager: "Care Manager",
  }[key] || key));
  const roleLabel = user?.is_super_admin
    ? translate("superAdmin")
    : translate(user?.role === "admin" ? "admin" : "care_manager");
  const parts = [`${user?.name || "—"} · ${roleLabel}`];
  if (user?.player_counts || user?.workload) {
    parts.push(`${user?.player_counts?.primary || 0} ${translate("primaryShort")}`);
    parts.push(`${translate("workloadLabel")} ${translate(`workload_${user?.workload?.level || "low"}`)}`);
  }
  if (user?.availability && !user.availability.available) {
    parts.push(user.availability.label || translate("notAvailable"));
  } else if (user?.next_leave?.start_date) {
    parts.push(`${translate("vacationFrom")} ${user.next_leave.start_date}`);
  } else if (user?.availability) {
    parts.push(translate("available"));
  }
  return parts.join(" · ");
};

export const fetchCareCapableUsers = async () => {
  const { data } = await api.get("/admin/care-managers");
  const unique = new Map();
  (data.care_managers || []).forEach((user) => unique.set(user.id, user));
  return [...unique.values()].sort((left, right) => (
    (left.name || "").localeCompare(right.name || "", undefined, { sensitivity: "base" })
  ));
};
